import React, { useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import { useOffer } from '../../../context/offersContext/OfferContextProvider';
import ActionButtons from '../../../components/common/ActionButtons';

const OfferTable = ({ handleEditOffer }) => {
  const { getOffers, offerRes, deleteOffer } = useOffer();
  const [scaledImage, setScaledImage] = useState(null); // State to track the clicked image for scaling
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      await getOffers();
      setLoading(false); // Stop loading
    };
    fetchData();
  }, []);

  // Handle image click: Set the clicked image for scaling
  const handleImageClick = (offerId) => {
    setScaledImage(offerId);
  };

  // Handle mouse leave: Reset the scaled image
  const handleMouseLeave = () => {
    setScaledImage(null); // Reset to original size on hover out
  };

  if (loading) {
    return (
      <div className="m-10 p-5">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="flex items-center justify-between border p-4 rounded-lg border-l-8 border-l-[#ffb800] my-4 shadow-md animate-pulse"
          >
            <div className="w-24 h-24 bg-gray-300 rounded-md"></div>
            <div className="flex-1 px-4">
              <div className="w-40 h-6 bg-gray-300 rounded"></div>
            </div>
            <div className="flex gap-5">
              <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
              <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
            </div>
          </div>
        ))}
      </div>
    ); // Show skeleton loading while fetching data
  }

  return (
    <div className="m-10 p-5">
      {offerRes.length === 0 ? (
        <div className="text-center text-gray-500">No offers available</div>
      ) : (
        offerRes.map((offer) => (
          <div
            key={offer.id}
            className="flex items-center justify-between border p-4 rounded-lg border-l-8 border-l-[#ffb800] my-4 shadow-md transition-transform hover:scale-105"
          >
            <div className="w-24">
              <img
                onMouseLeave={handleMouseLeave} // Reset image size when leaving the container
                src={offer.imageUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    'http://34.236.44.203/smartpro/Images/no-image.png?1723014762558';
                }}
                alt="No image available"
                className={`w-full h-24 object-cover rounded-md transition-transform duration-300 cursor-pointer border bg-white ${
                  scaledImage === offer.id ? 'scale-[2]' : 'scale-100'
                }`} // Scale to 200% on click, back to normal on hover out
                onMouseEnter={() => handleImageClick(offer.id)} // Scale the image on click
              />
            </div>
            <div className="flex-1 px-4">
              <div className="font-bold text-xl text-gray-700">
                {offer.offer}
              </div>
            </div>
            <ActionButtons
              actions={[
                {
                  icon: <FaTrash />,
                  onClick: () => deleteOffer(offer.id),
                  tooltip: 'Delete Offer',
                  className: 'text-red-600 pr-5',
                },
                {
                  icon: <MdEdit />,
                  onClick: () => handleEditOffer(offer),
                  tooltip: 'Edit Offer',
                  className: 'text-gray-600',
                },
              ]}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default OfferTable;
